module.exports = __webpack_public_path__ + "media/images/dashboard/darkBG-0a14ff3fec8c936bebc3e6cdf9152413.png";